import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

const DownloadSection = () => {
  return (
    <section id="download" className="py-20 bg-gradient-to-b from-background to-secondary/20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Download <span className="text-primary">Zuto</span> Today
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Available on iOS and Android. Transform your lectures into clean, structured study material.
          </p>
        </motion.div>
        
        <div className="flex flex-col sm:flex-row gap-8 justify-center items-center max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="w-full sm:w-1/2"
          >
            <a 
              href="https://apps.apple.com/us/app/zuto-ai-assistant/id6752733945" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <div className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer group">
                <div className="mb-4 flex justify-center">
                  <div className="w-16 h-16 rounded-2xl bg-black flex items-center justify-center group-hover:scale-110 transition-transform">
                    <svg className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2 text-card-foreground">iOS App Store</h3>
                <p className="text-muted-foreground mb-4">Download for iPhone and iPad</p>
                <div className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-semibold">
                  Download
                </div>
              </div>
            </a>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="w-full sm:w-1/2"
          >
            <a 
              href="https://play.google.com/store/apps/details?id=ai.zuto.app" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block"
            >
              <div className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-lg transition-shadow cursor-pointer group">
                <div className="mb-4 flex justify-center">
                  <div className="w-16 h-16 rounded-2xl bg-black flex items-center justify-center group-hover:scale-110 transition-transform">
                    <svg className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                    </svg>
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2 text-card-foreground">Google Play Store</h3>
                <p className="text-muted-foreground mb-4">Download for Android devices</p>
                <div className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-semibold">
                  Download
                </div>
              </div>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
